import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { param } from "jquery";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { MessageService } from "./message.service";

@Injectable({
    providedIn: 'root'
})

export class DocumentService {
    private documentUrl = location.origin + '/api/document/upload/';

    private token = localStorage.getItem('token');

    private headers = new HttpHeaders().set('Content-Type', 'application/json');
    private httpOptions = this.headers.append('Authorization', `Bearer ${this.token}`);

    constructor(private http: HttpClient, private messageService: MessageService) { }

    private getToken() {
        return this.headers.append('Authorization', `Bearer ${localStorage.getItem('token')}`);
    }

    getDocumentParentListByUser(isAdmin): Observable<any> {
        return this.http.get<any>(`${this.documentUrl}all?admin=${isAdmin}`, { headers: this.getToken() })
            .pipe();
    }

    addDocument(creaDocument): Observable<any> {
        return this.http.post<any>(`${this.documentUrl}new`, creaDocument, { headers: this.getToken() })
            .pipe();
    }

    changeDocumentStatus(id, status) {
        return this.http.get<any>(`${this.documentUrl}update/status/${id}/${status}`, { headers: this.getToken() })
            .pipe();
    }

    getDocumentDetail(id) {
        return this.http.get<any>(`${this.documentUrl}get/${id}`, { headers: this.getToken() })
            .pipe();
    }

    addDocumentUser(id, data) {
        return this.http.post<any>(`${this.documentUrl}add/file/${id}`, data, { headers: this.getToken() })
            .pipe();
    }
}